module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field",
    attrs: {
      "id": "task-editor-text"
    }
  }, [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined"
  }, [(_vm.isNameEditable) ? _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['name']))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_alignment']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alignment),
      expression: "alignment"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "center"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_center']))]), _c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_left']))])])])]), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_font']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fontname),
      expression: "fontname"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fontname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.FONTS), function(name) {
    return _c('option', {
      key: name
    }, [_vm._v(_vm._s(name))])
  }))])]), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['instructions']))]), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.intro),
      expression: "intro"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.intro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_none']))]), _vm._l((_vm.intros), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])])]), _c('p'), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined tip-parent"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['text']))])]), _c('div', {
    staticClass: "column is-narrow tip-header"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_formatting']))]), _c('task-text-formatting-instructions', {
    staticClass: "is-tip"
  })], 1), _c('p'), (_vm.hasTaskImagesBoundToWords) ? _c('div', {
    staticClass: "notification is-warning"
  }, [_vm._v(_vm._s(_vm.tokens['msg_not_editable']))]) : _vm._e(), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "textarea text",
    attrs: {
      "placeholder": _vm.tokens['text'],
      "disabled": _vm.hasTaskImagesBoundToWords
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11eeeada"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/taskEditorText.vue
// module id = 407
// module chunks = 0